import { mockCmsAlertPanel } from '@domgen/dgx-fe-cms';
import { CmsIneligiblePage } from '../../models/cms/cms-ineligible-page.interface';

export const mockCmsIneligiblePage: CmsIneligiblePage = {
  pageTitle: 'pageTitle',
  ineligibleAlertPanel: mockCmsAlertPanel,
};
